import React, { Component } from "react";

class Loading extends Component {
  render() {
    return (
        <h2>Searching...</h2>
    );
  }
}

export default Loading;
